import Decimal from 'decimal.js';

export const WEI_RATE = 1e18;

export class Convertor {
  static weiToEth(wei: string | number = 0): number {
    return new Decimal(wei).div(WEI_RATE).toNumber();
  }
}
